import { defineMessages } from 'react-intl';

/** The copy that more than one Outreach page shows (spec 2026-10-11, designs outreach a to q). */
export const outreachMessages = defineMessages({
  crumbPitch: { id: 'app.outreach.crumb.pitch', defaultMessage: 'Pitch' },
  demoData: { id: 'app.outreach.demo.note', defaultMessage: 'Demo data. Changes are off for the demo artist.' },
  close: { id: 'app.outreach.close', defaultMessage: 'Close' },
  cancel: { id: 'app.outreach.cancel', defaultMessage: 'Cancel' },
  save: { id: 'app.outreach.save', defaultMessage: 'Save' },
  tryAgain: { id: 'app.outreach.tryAgain', defaultMessage: 'Try again' },
  showMore: { id: 'app.outreach.showMore', defaultMessage: 'Show more' },
  addToList: { id: 'app.outreach.addToList', defaultMessage: 'Add to a list' },
  copy: { id: 'app.outreach.copy', defaultMessage: 'Copy' },
  copied: { id: 'app.outreach.copied', defaultMessage: 'Copied' },
  openLink: { id: 'app.outreach.openLink', defaultMessage: 'Open the link' },
  fit: { id: 'app.outreach.fit', defaultMessage: 'Fit {score}' },
  followers: { id: 'app.outreach.followers', defaultMessage: '{count, plural, one {# follower} other {# followers}}' },
  picked: { id: 'app.outreach.picked', defaultMessage: '{count} picked' },
  noEmail: { id: 'app.outreach.noEmail', defaultMessage: 'No email found' },

  // design: outreach a4 — the Free plan card.
  freeTitle: { id: 'app.outreach.free.title', defaultMessage: 'Pitching starts on a paid plan' },
  freeBody: {
    id: 'app.outreach.free.body',
    defaultMessage:
      'You can find who fits and read a draft of your pitch. On a paid plan, Plug pitches new people every day: {artist} a day on Plus, {pro} on Pro, {label} for each artist on Ultra.',
  },
  seePlans: { id: 'app.outreach.free.seePlans', defaultMessage: 'See plans' },
  lockedOnPaid: { id: 'app.outreach.free.lockPaid', defaultMessage: 'On a paid plan' },

  // The labels of the target kinds (frame c tabs).
  kindPlaylist: { id: 'app.outreach.kind.playlist', defaultMessage: 'Playlists' },
  kindPress: { id: 'app.outreach.kind.press', defaultMessage: 'Blogs' },
  kindNewsletter: { id: 'app.outreach.kind.newsletter', defaultMessage: 'Newsletters' },
  kindRadio: { id: 'app.outreach.kind.radio', defaultMessage: 'Radio' },
  kindPodcast: { id: 'app.outreach.kind.podcast', defaultMessage: 'Podcasts' },
  kindCreator: { id: 'app.outreach.kind.creator', defaultMessage: 'Creators' },
  kindCommunity: { id: 'app.outreach.kind.community', defaultMessage: 'Communities' },

  // The contact kinds (frame q1).
  contactKindCurator: { id: 'app.outreach.contactKind.curator', defaultMessage: 'Curator' },
  contactKindOutlet: { id: 'app.outreach.contactKind.outlet', defaultMessage: 'Press' },
  contactKindCreator: { id: 'app.outreach.contactKind.creator', defaultMessage: 'Creator' },
  contactKindPrivate: { id: 'app.outreach.contactKind.private', defaultMessage: 'Imported' },

  // The workspace contact status (frame q1).
  statusNew: { id: 'app.outreach.status.new', defaultMessage: 'New' },
  statusPitched: { id: 'app.outreach.status.pitched', defaultMessage: 'Pitched' },
  statusReplied: { id: 'app.outreach.status.replied', defaultMessage: 'Replied' },
  statusPlaced: { id: 'app.outreach.status.placed', defaultMessage: 'Placed' },
  statusDoNotContact: { id: 'app.outreach.status.doNotContact', defaultMessage: 'Do not contact' },

  // The campaign status (frame a1 campaigns).
  campaignDraft: { id: 'app.outreach.campaign.status.draft', defaultMessage: 'Draft' },
  campaignWriting: { id: 'app.outreach.campaign.status.writing', defaultMessage: 'Writing' },
  campaignReview: { id: 'app.outreach.campaign.status.review', defaultMessage: 'To review' },
  campaignScheduled: { id: 'app.outreach.campaign.status.scheduled', defaultMessage: 'Scheduled' },
  campaignSending: { id: 'app.outreach.campaign.status.sending', defaultMessage: 'Sending' },
  campaignPaused: { id: 'app.outreach.campaign.status.paused', defaultMessage: 'Paused' },
  campaignDone: { id: 'app.outreach.campaign.status.done', defaultMessage: 'Done' },

  // The source line of a contact point (frame c2, q1). The source line is on every contact row.
  sourcePlaylistDescription: {
    id: 'app.outreach.source.playlistDescription',
    defaultMessage: 'From the playlist description',
  },
  sourceWebsite: { id: 'app.outreach.source.website', defaultMessage: 'From their website' },
  sourceLinkInBio: { id: 'app.outreach.source.linkInBio', defaultMessage: 'From their link-in-bio page' },
  sourceInstagramPublic: {
    id: 'app.outreach.source.instagramPublic',
    defaultMessage: 'From their public Instagram profile',
  },
  sourceYoutubeAbout: { id: 'app.outreach.source.youtubeAbout', defaultMessage: 'From the YouTube channel About page' },
  sourceSoundcloud: { id: 'app.outreach.source.soundcloud', defaultMessage: 'From their SoundCloud profile' },
  sourceBandcamp: { id: 'app.outreach.source.bandcamp', defaultMessage: 'From their Bandcamp page' },
  sourceWebSearch: { id: 'app.outreach.source.webSearch', defaultMessage: 'From a page found by web search' },
  sourceNewsletterIndex: { id: 'app.outreach.source.newsletterIndex', defaultMessage: 'From their newsletter page' },
  sourcePodcastIndex: { id: 'app.outreach.source.podcastIndex', defaultMessage: 'From their podcast page' },
  sourcePodcastFeed: { id: 'app.outreach.source.podcastFeed', defaultMessage: 'From their podcast feed' },
  sourceTiktokPublic: { id: 'app.outreach.source.tiktokPublic', defaultMessage: 'From their public TikTok profile' },
  sourceRedditAbout: { id: 'app.outreach.source.redditAbout', defaultMessage: 'From their subreddit' },
  sourceImport: { id: 'app.outreach.source.import', defaultMessage: 'Imported by your workspace' },
  sourceAdmin: { id: 'app.outreach.source.admin', defaultMessage: 'Added by MUSIC24' },
  sourceLine: { id: 'app.outreach.source.line', defaultMessage: '{source} · found {date}' },
});
